export default "__VITE_ASSET__CVRmWgZh__"